export default "__VITE_ASSET__b_JtJ3I2__"